import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Encounter, EncounterPhase } from 'src/models';
import { ambientApi } from 'src/services';

export type UseUpdateEncounterDetailsPayload = {
  encounterId: Encounter['encounter_id'];
  encounterPhase: EncounterPhase;
  payload: Partial<
    Pick<
      Encounter,
      | 'pre_chart_status'
      | 'pre_chart_template_id'
      | 'pre_chart_template_overrides_id'
    >
  >;
};

export type UseUpdateEncounterDetailsResponse = Encounter;

export const useUpdateEncounterDetails = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['updateEncounterDetails'],
    mutationFn: ({ encounterId, payload }: UseUpdateEncounterDetailsPayload) =>
      ambientApi
        .put(`/encounters/${encounterId}`, payload)
        .then(({ data }) => data),
    onSuccess: (_, payload) => {
      // Invalidate and refetch encounter details
      queryClient.invalidateQueries({
        queryKey: ['encounterDetails', payload.encounterId],
      });

      // Invalidate encounter list queries
      queryClient.invalidateQueries({ queryKey: ['encounterList'] });
    },
  });
};
